var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-start"},_vm._l((_vm.items),function(item){return _c('Category',{key:item.label,staticClass:"mb-6",attrs:{"item":item,"isGlowing":_vm.glowingItems[item.label]},on:{"click":function($event){return _vm.onItemClick(item)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }